import plansSectionReducer from "./plans.section/plans.reducer"
import selectedPlanSectionReducer from "./plans-selected.section/plans-selected.reducer"

export const groupsWorksheetPageReducers = {
  groupPlans: plansSectionReducer,
  selectedGroupPlan: selectedPlanSectionReducer,
}
